import BaseMapper from '../../BaseMapper';

const MarketDescriptionMapper = (data, context) => {
    return data;
};

export default MarketDescriptionMapper;
